/**
 * Youro Discovery — natives Karten-Rendering fuer die Meilisearch-Suche.
 *
 * Bewusst GETRENNT von youro-search.js (der Datenschicht aus dem
 * youro-discovery-Projekt) - dieses Skript ist reines Theme-Glue-Code, das
 * NICHTS von der Kartenoptik nachbaut. Meilisearch liefert nur, WELCHE
 * Produkte (Handle) in welcher Reihenfolge - die eigentliche Karte (inkl.
 * Farb-Bullseyes, Marke, Preis) wird pro Treffer live vom Server ueber die
 * bestehende, echte snippets/product-item.liquid-Vorlage nachgeladen
 * (Shopify Section-Rendering-API, /products/{handle}?section_id=...) -
 * exakt dieselbe Karte wie auf jeder Kollektionsseite, keine zweite
 * Codepfad-Fehlerquelle (Michelle 15.07.).
 *
 * Voraussetzung: youro-search.js muss VOR diesem Skript geladen sein
 * (stellt window.YouroSearch.search bereit).
 */
(function (global) {
  'use strict';

  var RENDER_SECTION_ID = 'youro-search-item-render';
  var cardCache = {}; // handle -> HTML-String, spart wiederholte Nachladungen (z.B. Enter nach Autocomplete)

  // Ausverkaufte Treffer stabil ans Ende sortieren, nicht rausfiltern (fuer
  // eine moegliche Warteliste sichtbar lassen) - Michelle 17.07.
  function sortAvailableFirst(hits) {
    var available = [];
    var unavailable = [];
    hits.forEach(function (hit) {
      (hit.available === false ? unavailable : available).push(hit);
    });
    return available.concat(unavailable);
  }

  function fetchCardHtml(handle) {
    if (cardCache[handle]) {
      return Promise.resolve(cardCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + RENDER_SECTION_ID)
      .then(function (r) {
        if (!r.ok) { throw new Error('Kartenladen fehlgeschlagen (HTTP ' + r.status + ')'); }
        return r.text();
      })
      .then(function (html) {
        cardCache[handle] = html;
        return html;
      });
  }

  // Laedt alle Karten fuer eine Trefferliste PARALLEL, gibt sie aber in der
  // urspruenglichen (von Meilisearch vorgegebenen) Reihenfolge zurueck -
  // ein einzelner langsamer Treffer soll nicht alle anderen blockieren,
  // aber die Relevanz-Reihenfolge muss erhalten bleiben.
  function fetchCardsInOrder(hits) {
    return Promise.all(
      hits.map(function (hit) {
        return fetchCardHtml(hit.handle).catch(function () {
          return null; // einzelner fehlgeschlagener Treffer faellt einfach weg, statt die ganze Liste zu killen
        });
      })
    );
  }

  /**
   * Autocomplete-Kapsel: identische Optik zur Kollektionsseite statt des
   * simplen youro-search.js-eigenen Listen-Renderings.
   */
  function attachNativeAutocomplete(inputEl, resultsEl, options) {
    options = options || {};
    var limit = options.limit || 6;
    var debounceMs = options.debounceMs || 200;
    var timer = null;
    var requestId = 0;

    function close() {
      resultsEl.innerHTML = '';
      resultsEl.classList.remove('youro-search-results--open');
    }

    function runSearch(value) {
      if (!value) { close(); return; }
      requestId += 1;
      var thisRequestId = requestId;

      global.YouroSearch.search(value, limit).then(function (data) {
        if (thisRequestId !== requestId) { return; } // waehrenddessen ist bereits eine neuere Suche gestartet
        var hits = data.hits || [];
        if (!hits.length) {
          resultsEl.innerHTML = '<div class="youro-search-empty">Keine Treffer gefunden.</div>';
          resultsEl.classList.add('youro-search-results--open');
          return;
        }
        return fetchCardsInOrder(hits).then(function (cardHtmls) {
          if (thisRequestId !== requestId) { return; }
          resultsEl.innerHTML = cardHtmls.filter(Boolean).join('');
          resultsEl.classList.add('youro-search-results--open');
        });
      }).catch(function () {
        if (thisRequestId === requestId) { close(); }
      });
    }

    inputEl.addEventListener('input', function () {
      clearTimeout(timer);
      var value = inputEl.value.trim();
      timer = setTimeout(function () { runSearch(value); }, debounceMs);
    });

    document.addEventListener('click', function (e) {
      if (!resultsEl.contains(e.target) && e.target !== inputEl) {
        close();
      }
    });

    return { close: close };
  }

  // ── Filter-Sidebar (Lagerbestand, Preis, Sortierung) ─────────
  //
  // Optik so weit wie moeglich aus den echten Theme-CSS-Klassen der
  // Original-Filter (filter-form__group, filter-item, filter-item__toggle,
  // filter-item__radio) wiederverwendet - die sind rein CSS-gesteuert
  // (":checked", "[aria-hidden]") und brauchen keine Shopify-eigene
  // Steuerung. Nur die Klick-Logik ist neu, weil die Original-Steuerung nur
  // mit Shopifys eigener Suche spricht, nicht mit Meilisearch-Treffern
  // (Michelle 15.07., siehe Chat-Verlauf). Der Preis-Regler ist bewusst eine
  // einfache Zahlen-Eingabe statt des Original-Schiebereglers (der haengt an
  // einer Bibliothek, die nur innerhalb der Shopify-eigenen Suchsteuerung
  // laedt) - kann bei Bedarf spaeter nachgeruestet werden.

  // Ladezustand fuer die volle Ergebnisseite - einfacher Spinner statt des
  // EU-Sterne-Rings von vorhin (Michelle 21.07.: "das Sternenband haben wir
  // nirgendwo sonst, das ist ein bisschen bloed ... ganz simples
  // Ladezeichen"). Eigenes Overlay-Element (nicht Teil von grid.innerHTML),
  // damit es sich per position:absolute ueber die GANZE Breite (Sidebar +
  // Ergebnisse) zentrieren laesst statt nur in der Raster-Spalte.
  var LOADING_OVERLAY_HTML = '<div class="youro-search-loading-overlay">'
    + '<div class="youro-search-spinner"></div>'
    + '</div>';

  var SORT_OPTIONS = [
    { value: 'relevance', label: 'Relevanz' },
    { value: 'price_asc', label: 'Preis aufsteigend' },
    { value: 'price_desc', label: 'Preis absteigend' },
    { value: 'bestseller', label: 'Beliebtheit' }
  ];

  function sortValueToMeiliSort(value) {
    switch (value) {
      case 'price_asc': return ['price_min:asc'];
      case 'price_desc': return ['price_min:desc'];
      case 'bestseller': return ['bestseller_score:desc'];
      default: return undefined;
    }
  }

  // Laenderkuerzel -> lesbarer Name (Meilisearch liefert ISO-Codes, siehe
  // Phase-2c-Update des anderen Chats 17.07.)
  var COUNTRY_LABELS = { DE: 'Deutschland', PT: 'Portugal', PL: 'Polen', EU: 'EU (allgemein)', IT: 'Italien', ES: 'Spanien', FR: 'Frankreich', AT: 'Österreich', NL: 'Niederlande' };
  function humanizeCountry(code) { return COUNTRY_LABELS[code] || code; }

  // Kategorie-Pfade lesbar machen, z.B. "Damenmode/Bekleidung/Hosen" -> "Hosen
  // Damen" - gleiche Logik wie in youro-search.js (Kapsel), hier als eigene
  // Kopie, weil beide Dateien getrennte Module (IIFEs) ohne gemeinsamen
  // Scope sind.
  var TOP_LEVEL_LABELS = { Damenmode: 'Damen', Herrenmode: 'Herren', Kindermode: 'Kinder' };
  function humanizeProductType(path) {
    if (!path) { return ''; }
    if (path.indexOf('/') === -1) {
      return path.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    var parts = path.split('/');
    var leaf = parts[parts.length - 1];
    var qualifier = TOP_LEVEL_LABELS[parts[0]];
    if (qualifier && qualifier !== leaf) { return leaf + ' ' + qualifier; }
    return leaf;
  }

  function facetEntries(facetDistribution, field, max) {
    if (!facetDistribution || !facetDistribution[field]) { return []; }
    var dist = facetDistribution[field];
    return Object.keys(dist)
      .map(function (value) { return { value: value, count: dist[value] }; })
      .sort(function (a, b) { return b.count - a.count; })
      .slice(0, max);
  }

  function meiliQuote(value) { return '"' + String(value).replace(/"/g, '\\"') + '"'; }
  function meiliInList(field, values) {
    return field + ' IN [' + values.map(meiliQuote).join(', ') + ']';
  }

  function buildMeiliFilter(state, options) {
    options = options || {};
    var parts = [];
    if (state.available) { parts.push('available = true'); }
    // excludePrice: fuer die Ermittlung der Regler-Spanne selbst darf der
    // Preisfilter nicht mitgelten, sonst schrumpft die Spanne beim Ziehen auf
    // genau die aktuelle Auswahl und man kommt nie mehr zurueck auf breiter
    // (Michelle 17.07.: "die Spanne geht immer von billigstes... bis
    // teuerstes Produkt in der Suchergebnisseite").
    if (!options.excludePrice) {
      if (state.priceMin != null && state.priceMin !== '') { parts.push('price_min >= ' + Number(state.priceMin)); }
      if (state.priceMax != null && state.priceMax !== '') { parts.push('price_min <= ' + Number(state.priceMax)); }
    }
    if (state.productTypes && state.productTypes.length) { parts.push(meiliInList('product_type', state.productTypes)); }
    if (state.vendors && state.vendors.length) { parts.push(meiliInList('vendor_name', state.vendors)); }
    if (state.colors && state.colors.length) { parts.push(meiliInList('colors', state.colors)); }
    if (state.countries && state.countries.length) { parts.push(meiliInList('country_of_origin', state.countries)); }
    // Patroa-Studio-Sichtbarkeit einschraenken (Entscheidung 014, anderer
    // Chat 16.07.) - Regel zentral in youro-search.js gepflegt, hier nur
    // aufgerufen. Greift automatisch fuer Hybrid- UND Fallback-Suche sowie
    // die Preis-Spannen-Anfrage, da alle drei buildMeiliFilter() nutzen.
    if (global.YouroSearch && global.YouroSearch.buildRestrictedVendorClause) {
      var vendorClause = global.YouroSearch.buildRestrictedVendorClause(state.q, state.vendors);
      if (vendorClause) { parts.push(vendorClause); }
    }
    return parts.length ? parts.join(' AND ') : undefined;
  }

  function readStateFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var colors = params.get('colors');
    var countries = params.get('countries');
    var vendors = params.get('vendors');
    // "product_type" kommt als EINZELWERT von den Kategorien-Chips in der
    // Autocomplete-Kapsel (aeltere Verlinkung) - hier zu einer Mehrfachauswahl-
    // Liste aufwerten, Komma-Liste bleibt abwaertskompatibel.
    var productTypes = params.get('product_type');
    // Seitenzahl fuer die Pagination (2026-10-08, Bug-Report: "nur die
    // ersten 24 Treffer sichtbar, Rest nicht erreichbar"). Direkt aus der
    // URL lesbar, damit ein Link auf Seite 3 auch direkt dorthin fuehrt.
    var pageParam = parseInt(params.get('page'), 10);
    return {
      q: params.get('q') || '',
      sort: params.get('sort') || 'relevance',
      available: params.get('available') === '1',
      priceMin: params.get('price_min') || '',
      priceMax: params.get('price_max') || '',
      productTypes: productTypes ? productTypes.split(',') : [],
      vendors: vendors ? vendors.split(',') : [],
      colors: colors ? colors.split(',') : [],
      countries: countries ? countries.split(',') : [],
      page: pageParam && pageParam > 0 ? pageParam : 1
    };
  }

  function writeStateToUrl(state) {
    var params = new URLSearchParams();
    if (state.q) { params.set('q', state.q); }
    if (state.sort && state.sort !== 'relevance') { params.set('sort', state.sort); }
    if (state.available) { params.set('available', '1'); }
    if (state.priceMin !== '') { params.set('price_min', state.priceMin); }
    if (state.priceMax !== '') { params.set('price_max', state.priceMax); }
    if (state.productTypes && state.productTypes.length) { params.set('product_type', state.productTypes.join(',')); }
    if (state.vendors && state.vendors.length) { params.set('vendors', state.vendors.join(',')); }
    if (state.colors && state.colors.length) { params.set('colors', state.colors.join(',')); }
    if (state.countries && state.countries.length) { params.set('countries', state.countries.join(',')); }
    if (state.page && state.page > 1) { params.set('page', state.page); }
    var newUrl = window.location.pathname + '?' + params.toString();
    window.history.replaceState(null, '', newUrl);
  }

  function buildToggleFilterItem(labelText, count, checked, onChange) {
    // "visually-hidden" wie im Original (filter-item.liquid) - sonst sieht
    // man Browser-Standard-Checkbox UND den gestylten Toggle uebereinander
    // (Michelle 15.07., Vergleichsscreenshot mit der echten Seite: "doppelte
    // Kreise").
    var listWrap = document.createElement('div');
    listWrap.className = 'filter-form__list-wrapper';
    listWrap.setAttribute('data-is-boolean', 'true');

    var list = document.createElement('ul');
    list.className = 'filter-form__list';

    var item = document.createElement('li');
    item.className = 'filter-item';
    item.setAttribute('data-filter-item-type', 'boolean');

    var label = document.createElement('label');
    label.className = 'filter-item__content';

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'filter-item__checkbox visually-hidden';
    checkbox.checked = checked;
    label.appendChild(checkbox);

    var inner = document.createElement('div');
    inner.className = 'filter-item__content-inner';

    var toggle = document.createElement('div');
    toggle.className = 'filter-item__toggle';
    inner.appendChild(toggle);

    var labelWrap = document.createElement('span');
    labelWrap.className = 'filter-item__label-wrapper';
    var text = document.createElement('span');
    text.className = 'filter-item__label';
    text.appendChild(document.createTextNode(labelText + ' '));
    // Zahlen wieder eingeblendet (18.07.): der andere Chat hat die Ursache
    // gefunden und behoben (page/hitsPerPage statt limit/offset, damit
    // Meilisearch den rankingScoreThreshold auch bei der Facettenzaehlung
    // beruecksichtigt) - live nachgeprueft, stimmt jetzt.
    var countEl = document.createElement('span');
    countEl.className = 'filter-item__count fs-body-60';
    countEl.textContent = '(' + count + ')';
    text.appendChild(countEl);
    labelWrap.appendChild(text);
    inner.appendChild(labelWrap);

    label.appendChild(inner);
    item.appendChild(label);
    list.appendChild(item);
    listWrap.appendChild(list);

    checkbox.addEventListener('change', function () { onChange(checkbox.checked); });
    return {
      el: listWrap,
      setCount: function (newCount) { countEl.textContent = '(' + newCount + ')'; }
    };
  }

  // Original-Filter-Icon aus snippets/icon.liquid (when 'filter') - fehlte
  // bisher am "Filter ausblenden/anzeigen"-Button (Michelle 16.07.,
  // Vergleichsscreenshot mit der alten nativen Suche).
  function buildFilterIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('fill', 'none');
    var paths = [
      'M3.90476 6.28571H12M20.0952 6.28571H18.1905',
      'M13.9048 6.28571C13.9048 5.23374 14.7575 4.38095 15.8095 4.38095C16.8615 4.38095 17.7143 5.23374 17.7143 6.28571C17.7143 7.33769 16.8615 8.19048 15.8095 8.19048C14.7575 8.19048 13.9048 7.33769 13.9048 6.28571Z',
      'M3.90476 12H7.71429M20.0952 12H12.9524',
      'M7.2381 12C7.2381 10.948 8.09089 10.0952 9.14286 10.0952C10.1948 10.0952 11.0476 10.948 11.0476 12C11.0476 13.052 10.1948 13.9048 9.14286 13.9048C8.09089 13.9048 7.2381 13.052 7.2381 12Z',
      'M3.90476 17.7143H9.61905M20.0952 17.7143C17.4917 17.7143 17.9369 17.7143 15.3333 17.7143',
      'M11.5238 17.7143C11.5238 16.6623 12.3766 15.8095 13.4286 15.8095C14.4806 15.8095 15.3333 16.6623 15.3333 17.7143C15.3333 18.7663 14.4806 19.619 13.4286 19.619C12.3766 19.619 11.5238 18.7663 11.5238 17.7143Z'
    ];
    paths.forEach(function (d) {
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', d);
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.25');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
    });
    return svg;
  }

  function buildChevronIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    var poly = document.createElementNS(ns, 'polyline');
    poly.setAttribute('points', '6 9 12 15 18 9');
    poly.setAttribute('fill', 'none');
    poly.setAttribute('stroke', 'currentColor');
    poly.setAttribute('stroke-width', '2');
    poly.setAttribute('stroke-linecap', 'round');
    poly.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(poly);
    return svg;
  }

  // Original-Icon-Pfade aus snippets/icon.liquid, direkt uebernommen fuer
  // die Desktop-Sortierung/Kachel-Listen-Umschaltung/Mobile-Schublade
  // (Michelle 18.07.: "genauso wie es im Original ist").
  function buildIconFromPaths(paths, width, height) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', width || '20');
    svg.setAttribute('height', height || '20');
    svg.setAttribute('fill', 'none');
    paths.forEach(function (attrs) {
      var path = document.createElementNS(ns, 'path');
      Object.keys(attrs).forEach(function (key) { path.setAttribute(key, attrs[key]); });
      svg.appendChild(path);
    });
    return svg;
  }

  function buildGridIcon() {
    return buildIconFromPaths([
      { d: 'M9.30005 3.6748H4.80005C4.17873 3.6748 3.67505 4.17848 3.67505 4.7998V9.2998C3.67505 9.92112 4.17873 10.4248 4.80005 10.4248H9.30005C9.92137 10.4248 10.425 9.92112 10.425 9.2998V4.7998C10.425 4.17848 9.92137 3.6748 9.30005 3.6748Z', stroke: 'currentColor', 'stroke-width': '1.25' },
      { d: 'M9.30005 13.5752H4.80005C4.17873 13.5752 3.67505 14.0789 3.67505 14.7002V19.2002C3.67505 19.8215 4.17873 20.3252 4.80005 20.3252H9.30005C9.92137 20.3252 10.425 19.8215 10.425 19.2002V14.7002C10.425 14.0789 9.92137 13.5752 9.30005 13.5752Z', stroke: 'currentColor', 'stroke-width': '1.25' },
      { d: 'M19.2 3.6748H14.7C14.0787 3.6748 13.575 4.17848 13.575 4.7998V9.2998C13.575 9.92112 14.0787 10.4248 14.7 10.4248H19.2C19.8213 10.4248 20.325 9.92112 20.325 9.2998V4.7998C20.325 4.17848 19.8213 3.6748 19.2 3.6748Z', stroke: 'currentColor', 'stroke-width': '1.25' },
      { d: 'M19.2 13.5752H14.7C14.0787 13.5752 13.575 14.0789 13.575 14.7002V19.2002C13.575 19.8215 14.0787 20.3252 14.7 20.3252H19.2C19.8213 20.3252 20.325 19.8215 20.325 19.2002V14.7002C20.325 14.0789 19.8213 13.5752 19.2 13.5752Z', stroke: 'currentColor', 'stroke-width': '1.25' }
    ]);
  }

  function buildListIcon() {
    return buildIconFromPaths([
      { d: 'M19.2001 3.6748H4.80005C4.17873 3.6748 3.67505 4.17848 3.67505 4.7998V9.2998C3.67505 9.92112 4.17873 10.4248 4.80005 10.4248H19.2001C19.8214 10.4248 20.325 9.92112 20.325 9.2998V4.7998C20.325 4.17848 19.8214 3.6748 19.2001 3.6748Z', stroke: 'currentColor', 'stroke-width': '1.25' },
      { d: 'M19.2001 13.5752H4.80005C4.17873 13.5752 3.67505 14.0789 3.67505 14.7002V19.2002C3.67505 19.8215 4.17873 20.3252 4.80005 20.3252H19.2001C19.8214 20.3252 20.325 19.8215 20.325 19.2002V14.7002C20.325 14.0789 19.8214 13.5752 19.2001 13.5752Z', stroke: 'currentColor', 'stroke-width': '1.25' }
    ]);
  }

  function buildSortIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    ['M7.09252 18.9151C7.25828 18.9151 7.41725 18.8524 7.53446 18.7408L10.9531 15.4849C11.1972 15.2525 11.1972 14.8755 10.9531 14.6431C10.7091 14.4107 10.3134 14.4107 10.0693 14.6431L7.71752 16.8829V5.68025C7.71752 5.3515 7.4377 5.08501 7.09252 5.08501C6.74734 5.08501 6.46752 5.3515 6.46752 5.68025V16.8829L4.11577 14.6431C3.87169 14.4107 3.47596 14.4107 3.23189 14.6431C2.98781 14.8755 2.98781 15.2525 3.23189 15.4849L6.65058 18.7408C6.76779 18.8524 6.92676 18.9151 7.09252 18.9151Z',
     'M20.9502 7.53246H12.9502V6.34198H20.9502V7.53246ZM20.9502 12.2944H12.9502V11.1039H20.9502V12.2944ZM12.9502 17.0563H20.9502V15.8658H12.9502V17.0563Z'].forEach(function (d) {
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('fill-rule', 'evenodd');
      path.setAttribute('clip-rule', 'evenodd');
      path.setAttribute('d', d);
      path.setAttribute('fill', 'currentColor');
      svg.appendChild(path);
    });
    return svg;
  }

  function buildArrowShortIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M0 12.4016H11.5H23M23 12.4016L13.8 3M23 12.4016L13.8 21.8032');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.75');
    svg.appendChild(path);
    return svg;
  }

  function buildCloseIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M6 6L12.25 12.25M18.5 18.5L12.25 12.25M12.25 12.25L18.5 6M12.25 12.25L6 18.5');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.16667');
    path.setAttribute('stroke-linecap', 'square');
    svg.appendChild(path);
    return svg;
  }

  function buildChevronSmallIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '10');
    svg.setAttribute('height', '10');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M1.875 7.438 12 17.563 22.125 7.438');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.75');
    path.setAttribute('fill', 'none');
    svg.appendChild(path);
    return svg;
  }

  // Kachel-/Listenansicht-Umschalter (Original-Klassen item-layout-toggle*) -
  // steuert data-item-layout auf der Suchsektion, dieselbe CSS-Klasse wie im
  // Original entscheidet dann ueber Grid- vs. Listen-Darstellung.
  function buildItemLayoutToggle(rootEl) {
    var wrap = document.createElement('div');
    wrap.className = 'item-layout-toggle';

    function buildBtn(type, icon) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'item-layout-toggle__button';
      btn.setAttribute('data-layout-type', type);
      btn.setAttribute('data-is-active', type === 'grid' ? 'true' : 'false');
      btn.setAttribute('aria-label', type === 'grid' ? 'Kachelansicht' : 'Listenansicht');
      btn.appendChild(icon);
      return btn;
    }

    var gridBtn = buildBtn('grid', buildGridIcon());
    var listBtn = buildBtn('list', buildListIcon());
    wrap.appendChild(gridBtn);
    wrap.appendChild(listBtn);

    function setLayout(type) {
      rootEl.setAttribute('data-item-layout', type);
      gridBtn.setAttribute('data-is-active', type === 'grid' ? 'true' : 'false');
      listBtn.setAttribute('data-is-active', type === 'list' ? 'true' : 'false');
    }
    gridBtn.addEventListener('click', function () { setLayout('grid'); });
    listBtn.addEventListener('click', function () { setLayout('list'); });

    return wrap;
  }

  // Sortier-Dropdown im Topbar (Michelle 18.07.: "rechtsbuendig auf dem
  // Desktop, zum Ausklappen als Dropdown") - Original-Klassen
  // filter-topbar__sort-toggle/filter-bar__sort-values, CSS macht daraus
  // automatisch Dropdown (Desktop) bzw. Vollbild-Sheet (Mobile).
  function buildSortDropdown(state, onChange) {
    var group = document.createElement('div');
    group.className = 'filter-bar__sort-group';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'filter-topbar__sort-toggle btn btn--tertiary';
    toggle.setAttribute('aria-expanded', 'false');

    var sortIconWrap = document.createElement('span');
    sortIconWrap.className = 'icon-sort';
    sortIconWrap.appendChild(buildSortIcon());
    toggle.appendChild(sortIconWrap);

    function currentLabel() {
      var found = SORT_OPTIONS.filter(function (o) { return o.value === state.sort; })[0];
      return found ? found.label : SORT_OPTIONS[0].label;
    }

    var labelDesktop = document.createElement('span');
    labelDesktop.className = 'filter-topbar__sort-label-desktop';
    labelDesktop.textContent = 'Sortierung: ' + currentLabel();
    toggle.appendChild(labelDesktop);

    var labelMobile = document.createElement('span');
    labelMobile.className = 'filter-topbar__sort-label-mobile';
    labelMobile.textContent = 'Sortierung';
    toggle.appendChild(labelMobile);

    var chevronWrap = document.createElement('span');
    chevronWrap.className = 'icon-chevron-small';
    chevronWrap.appendChild(buildChevronSmallIcon());
    toggle.appendChild(chevronWrap);
    group.appendChild(toggle);

    var panel = document.createElement('div');
    panel.className = 'filter-bar__sort-values';
    panel.setAttribute('aria-hidden', 'true');

    var panelInner = document.createElement('div');
    panelInner.className = 'filter-bar__sort-values-inner';

    var panelHeader = document.createElement('div');
    panelHeader.className = 'filter-bar__sort-values-header';
    var panelTitle = document.createElement('h4');
    panelTitle.className = 'filter-bar__sort-title';
    panelTitle.textContent = 'Sortierung';
    panelHeader.appendChild(panelTitle);
    var panelClose = document.createElement('button');
    panelClose.type = 'button';
    panelClose.className = 'filter-bar__sort-close';
    panelClose.setAttribute('aria-label', 'Schliessen');
    panelClose.appendChild(buildCloseIcon());
    panelHeader.appendChild(panelClose);
    panelInner.appendChild(panelHeader);

    var list = document.createElement('ul');
    list.className = 'filter-bar__sort-list';

    function close() {
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }
    function open() {
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
    }

    SORT_OPTIONS.forEach(function (option) {
      var li = document.createElement('li');
      li.className = 'filter-item';
      var label = document.createElement('label');
      label.className = 'filter-item__content';
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'youro-sort-topbar';
      radio.className = 'filter-item__radio visually-hidden';
      radio.checked = state.sort === option.value;
      label.appendChild(radio);
      var inner = document.createElement('div');
      inner.className = 'filter-item__content-inner';
      var indicatorWrap = document.createElement('div');
      indicatorWrap.className = 'filter-input__input';
      var indicator = document.createElement('div');
      indicator.className = 'indicator';
      indicatorWrap.appendChild(indicator);
      inner.appendChild(indicatorWrap);
      var text = document.createElement('span');
      text.className = 'filter-item__label';
      text.textContent = option.label;
      inner.appendChild(text);
      label.appendChild(inner);
      li.appendChild(label);
      list.appendChild(li);

      radio.addEventListener('change', function () {
        labelDesktop.textContent = 'Sortierung: ' + option.label;
        close();
        onChange(option.value);
      });
    });
    panelInner.appendChild(list);
    panel.appendChild(panelInner);

    var wash = document.createElement('div');
    wash.className = 'filter-bar__sort-values-wash';
    panel.appendChild(wash);

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) { close(); } else { open(); }
    });
    panelClose.addEventListener('click', close);
    wash.addEventListener('click', close);

    group.appendChild(panel);
    return group;
  }

  function buildFilterGroup(labelText, contentEl) {
    var group = document.createElement('div');
    group.className = 'filter-form__group';

    var toggleWrap = document.createElement('div');
    toggleWrap.className = 'filter-form__group-toggle-wrapper';

    var toggleBtn = document.createElement('button');
    toggleBtn.type = 'button';
    toggleBtn.className = 'filter-form__group-toggle';
    toggleBtn.setAttribute('aria-expanded', 'true');

    var toggleInner = document.createElement('span');
    toggleInner.className = 'filter-form__group-toggle-inner';
    var toggleLabel = document.createElement('span');
    toggleLabel.className = 'filter-form__group-toggle-label ff-body fs-body-bold';
    toggleLabel.textContent = labelText;
    toggleInner.appendChild(toggleLabel);
    toggleBtn.appendChild(toggleInner);
    toggleBtn.appendChild(buildChevronIcon());
    toggleWrap.appendChild(toggleBtn);
    group.appendChild(toggleWrap);

    var wrapper = document.createElement('div');
    wrapper.className = 'filter-form__group-filter-wrapper';
    wrapper.setAttribute('aria-hidden', 'false');
    wrapper.appendChild(contentEl);
    group.appendChild(wrapper);

    toggleBtn.addEventListener('click', function () {
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      wrapper.setAttribute('aria-hidden', expanded ? 'true' : 'false');
    });

    return group;
  }

  function buildCheckmarkIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('fill', 'none');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'm1.88 11.988 6.21 6.103L22.467 3.83');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '3.055');
    svg.appendChild(path);
    return svg;
  }

  // Farbname (Meilisearch liefert deutsche/englische Wortnamen, keine
  // CSS-Farbwerte) -> tatsaechliche Farbe fuer den Kreis, wie im Original
  // (Michelle 17.07.: "im Original waren so Farbbullseyes"). Beste Annaeherung
  // pro Name, keine amtliche Pantone-Zuordnung.
  var COLOR_SWATCH_MAP = {
    amber: '#FFBF00', apricot: '#FBCEB1', aubergine: '#3D1E33', beige: '#E8DCC4',
    berry: '#8B0045', black: '#101010', blau: '#1E4FA8', braun: '#6B4423',
    cider: '#A85C32', 'cobalt blue': '#0047AB', dunkelblau: '#1B2A4A', dunkelgrün: '#1F4D2C',
    fuchsia: '#C2185B', grau: '#9B9B9B', grün: '#3C7A3C', lapis: '#26619C',
    lavendel: '#B497BD', mint: '#98D8C1', natur: '#DCC9A3', orange: '#E8752C',
    pecan: '#7B4B27', petrol: '#0B4F5C', rosa: '#E58CA5', rot: '#C23B3B',
    schwarz: '#101010', sky: '#87CEEB', weiß: '#F5F5F0', white: '#F5F5F0',
    silber: '#C0C0C0', silver: '#C0C0C0', gold: '#D4AF37', gelb: '#F2D027',
    türkis: '#30D5C8', turkis: '#30D5C8', lila: '#8B5FBF', violett: '#8B5FBF',
    koralle: '#FF6F61', creme: '#F5F0DC', khaki: '#8B8557', oliv: '#6B6B2A',
    marine: '#1B2A4A', bordeaux: '#5E1A28', senf: '#C9A227', kupfer: '#B36A45',
    taupe: '#8B7D6B', anthrazit: '#2F2F2F', ivory: '#F5EFDE', navy: '#1B2A4A',
    pink: '#E58CA5', gruen: '#3C7A3C', tuerkis: '#30D5C8'
  };

  // Falls kein exakter Treffer da ist (z.B. "Neongelb" statt "Gelb"): pruefen,
  // ob der Name eine bekannte Grundfarbe ENTHAELT - laengster Treffer zuerst,
  // damit "Dunkelblau" nicht faelschlich nur "blau" matcht, obwohl es schon
  // einen eigenen Eintrag hat (Michelle 17.07.: "die sind leider nicht in der
  // Farbe gefüllt").
  var COLOR_SWATCH_KEYS_BY_LENGTH = Object.keys(COLOR_SWATCH_MAP).sort(function (a, b) { return b.length - a.length; });

  function resolveSwatchColor(key) {
    if (COLOR_SWATCH_MAP[key]) { return COLOR_SWATCH_MAP[key]; }
    for (var i = 0; i < COLOR_SWATCH_KEYS_BY_LENGTH.length; i++) {
      var base = COLOR_SWATCH_KEYS_BY_LENGTH[i];
      if (key.indexOf(base) !== -1) { return COLOR_SWATCH_MAP[base]; }
    }
    return null;
  }

  function buildSwatch(colorName) {
    var wrapper = document.createElement('div');
    wrapper.className = 'filter-item__swatch-wrapper';
    wrapper.setAttribute('data-shape', 'round');

    var swatch = document.createElement('div');
    swatch.className = 'filter-item__swatch';
    var key = colorName.toLowerCase();
    if (key === 'mehrfarbig' || key === 'multicolor') {
      swatch.style.background = 'conic-gradient(#E8752C 0deg, #E8DCC4 90deg, #3C7A3C 180deg, #1E4FA8 270deg, #E8752C 360deg)';
    } else {
      swatch.style.backgroundColor = resolveSwatchColor(key) || '#C9C2B8';
    }

    var iconWrap = document.createElement('span');
    iconWrap.className = 'icon';
    iconWrap.appendChild(buildCheckmarkIcon());
    swatch.appendChild(iconWrap);

    wrapper.appendChild(swatch);
    return wrapper;
  }

  // Mehrfachauswahl-Filter (Farbe, Produktionsland) - erst moeglich seit dem
  // Phase-2c-Index-Update des anderen Chats 17.07. (colors, country_of_origin
  // wurden neu als filterbare Felder ergaenzt).
  // Ab wie vielen Eintraegen gekuerzt wird - eine einzelne lange Filterliste
  // soll nicht den naechsten Filter aus dem Blick draengen (Michelle 18.07.).
  var TRUNCATE_VISIBLE_COUNT = 3;

  function buildCheckboxGroup(labelText, entries, humanize, selectedValues, onToggle, swatches) {
    // Eine einzige, durchgehende Liste (nicht in zwei <ul> aufgeteilt) - die
    // Original-CSS-Abstandsregel zwischen Filter-Optionen wirkt nur zwischen
    // direkten Geschwister-Elementen; eine verschachtelte zweite Liste fuer
    // die "mehr"-Eintraege hatte den Abstand zwischen Eintrag 3 und 4 kaputt
    // gemacht UND dafuer gesorgt, dass beim Zu-/Wiederaufklappen der ganzen
    // Filtergruppe die Kuerzung verloren ging (Michelle 18.07.). Kuerzung
    // jetzt rein optisch ueber Hoehenbegrenzung auf der Liste selbst.
    var list = document.createElement('ul');
    list.className = 'filter-form__list youro-filter-list';

    entries.forEach(function (entry, index) {
      var li = document.createElement('li');
      li.className = 'filter-item';

      var label = document.createElement('label');
      label.className = 'filter-item__content';

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'filter-item__checkbox visually-hidden';
      checkbox.checked = selectedValues.indexOf(entry.value) !== -1;
      label.appendChild(checkbox);

      var inner = document.createElement('div');
      inner.className = 'filter-item__content-inner';

      if (swatches) {
        inner.appendChild(buildSwatch(entry.value));
      } else {
        var checkWrap = document.createElement('div');
        checkWrap.className = 'filter-input__input';
        checkWrap.appendChild(buildCheckmarkIcon());
        inner.appendChild(checkWrap);
      }

      var labelWrap = document.createElement('span');
      labelWrap.className = 'filter-item__label-wrapper';
      var text = document.createElement('span');
      text.className = 'filter-item__label';
      text.appendChild(document.createTextNode(humanize(entry.value) + ' '));
      var countEl = document.createElement('span');
      countEl.className = 'filter-item__count fs-body-60';
      countEl.textContent = '(' + entry.count + ')';
      text.appendChild(countEl);
      labelWrap.appendChild(text);
      inner.appendChild(labelWrap);

      label.appendChild(inner);
      li.appendChild(label);
      list.appendChild(li);

      checkbox.addEventListener('change', function () { onToggle(entry.value, checkbox.checked); });
    });

    var wrap = document.createElement('div');
    wrap.appendChild(list);

    if (entries.length > TRUNCATE_VISIBLE_COUNT) {
      // Vierter Eintrag halb sichtbar mit Ausblend-Verlauf, statt komplett
      // versteckt - macht sichtbar, dass noch mehr da ist (Michelle 18.07.:
      // "die vierte so halb geblurrt als auf halber Hoehe"). Keine Zahl mehr
      // im Toggle-Text (Michelle 18.07., zweite Praezisierung).
      list.setAttribute('data-expanded', 'false');

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'filter-form__truncate-toggle';
      var toggleText = document.createElement('span');
      toggleText.className = 'filter-form__truncate-toggle-text';
      toggleText.textContent = 'Alle anzeigen';
      toggle.appendChild(toggleText);
      var toggleIcon = buildChevronIcon();
      toggleIcon.classList.add('youro-filter-more__toggle-icon');
      toggle.appendChild(toggleIcon);
      wrap.appendChild(toggle);

      toggle.addEventListener('click', function () {
        var expanded = list.getAttribute('data-expanded') === 'true';
        list.setAttribute('data-expanded', expanded ? 'false' : 'true');
        toggleText.textContent = expanded ? 'Alle anzeigen' : 'Weniger anzeigen';
      });
    }

    return buildFilterGroup(labelText, wrap);
  }

  function buildSortGroup(state, onChange) {
    var list = document.createElement('ul');
    list.className = 'filter-form__list';
    SORT_OPTIONS.forEach(function (option) {
      var li = document.createElement('li');
      li.className = 'filter-item';

      var label = document.createElement('label');
      label.className = 'filter-item__content';

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'youro-sort';
      radio.className = 'filter-item__radio visually-hidden';
      radio.checked = state.sort === option.value;
      label.appendChild(radio);

      var inner = document.createElement('div');
      inner.className = 'filter-item__content-inner';
      var indicatorWrap = document.createElement('div');
      indicatorWrap.className = 'filter-input__input';
      var indicator = document.createElement('div');
      indicator.className = 'indicator';
      indicatorWrap.appendChild(indicator);
      inner.appendChild(indicatorWrap);

      var text = document.createElement('span');
      text.className = 'filter-item__label';
      text.textContent = option.label;
      inner.appendChild(text);

      label.appendChild(inner);
      li.appendChild(label);
      list.appendChild(li);

      radio.addEventListener('change', function () { onChange(option.value); });
    });
    return buildFilterGroup('Sortierung', list);
  }

  // Eigener Zwei-Griff-Schieberegler (kein noUiSlider - haengt an einer
  // Bibliothek, die nur innerhalb der Shopify-eigenen Suchsteuerung laedt,
  // siehe Chat-Verlauf 15.07.) - zieht sich aber genauso beidseitig wie das
  // Original (Michelle 16.07.: "beidseitig links und rechts, dass man das
  // schieben kann").
  function buildDualSlider(rangeMin, rangeMax, currentMin, currentMax, onDrag, onCommit) {
    var el = document.createElement('div');
    el.className = 'filter-form__slider youro-price-slider';

    var track = document.createElement('div');
    track.className = 'youro-price-slider__track';
    el.appendChild(track);

    var rangeBar = document.createElement('div');
    rangeBar.className = 'youro-price-slider__range';
    el.appendChild(rangeBar);

    var handleMin = document.createElement('button');
    handleMin.type = 'button';
    handleMin.className = 'youro-price-slider__handle';
    handleMin.setAttribute('aria-label', 'Mindestpreis');
    el.appendChild(handleMin);

    var handleMax = document.createElement('button');
    handleMax.type = 'button';
    handleMax.className = 'youro-price-slider__handle';
    handleMax.setAttribute('aria-label', 'Höchstpreis');
    el.appendChild(handleMax);

    var span = rangeMax - rangeMin || 1;
    var min = currentMin;
    var max = currentMax;

    function valueToPercent(v) { return ((v - rangeMin) / span) * 100; }

    function render() {
      var minPct = valueToPercent(min);
      var maxPct = valueToPercent(max);
      handleMin.style.left = minPct + '%';
      handleMax.style.left = maxPct + '%';
      rangeBar.style.left = minPct + '%';
      rangeBar.style.width = (maxPct - minPct) + '%';
    }
    render();

    function percentFromEvent(e) {
      var rect = track.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return Math.min(100, Math.max(0, (x / rect.width) * 100));
    }

    function startDrag(handleType) {
      return function (downEvent) {
        downEvent.preventDefault();
        function move(moveEvent) {
          var pct = percentFromEvent(moveEvent);
          var value = Math.round(rangeMin + (pct / 100) * span);
          if (handleType === 'min') {
            min = Math.min(value, max);
          } else {
            max = Math.max(value, min);
          }
          render();
          onDrag(min, max);
        }
        function up() {
          document.removeEventListener('pointermove', move);
          document.removeEventListener('pointerup', up);
          onCommit(min, max);
        }
        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
      };
    }

    handleMin.addEventListener('pointerdown', startDrag('min'));
    handleMax.addEventListener('pointerdown', startDrag('max'));

    return {
      el: el,
      setValues: function (newMin, newMax) { min = newMin; max = newMax; render(); },
      // Aeussere Spanne selbst aktualisieren (nicht nur die aktuell
      // gezogenen Werte) - wird bei jeder Trefferaktualisierung neu gesetzt.
      setRange: function (newRangeMin, newRangeMax) {
        rangeMin = newRangeMin;
        rangeMax = newRangeMax;
        span = (rangeMax - rangeMin) || 1;
        min = Math.max(rangeMin, Math.min(min, rangeMax));
        max = Math.max(rangeMin, Math.min(max, rangeMax));
        render();
      }
    };
  }

  function buildPriceGroup(state, priceStats, onChange) {
    var wrap = document.createElement('div');
    wrap.className = 'filter-form__price-range';

    var inputWrap = document.createElement('div');
    inputWrap.className = 'filter-form__price-range-input-wrapper';

    function buildInput(value, placeholder) {
      var box = document.createElement('div');
      box.className = 'filter-form__price-range-input';
      var currency = document.createElement('span');
      currency.className = 'filter-form__price-range-currency';
      currency.textContent = '€';
      box.appendChild(currency);
      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'input';
      input.min = '0';
      input.placeholder = placeholder;
      if (value !== '') { input.value = value; }
      box.appendChild(input);
      return { box: box, input: input };
    }

    var rangeMin = priceStats ? Math.floor(priceStats.min) : 0;
    var rangeMax = priceStats ? Math.ceil(priceStats.max) : 1000;

    var min = buildInput(state.priceMin, rangeMin);
    var sep = document.createElement('span');
    sep.className = 'filter-form__price-range-separator';
    sep.textContent = 'bis';
    var max = buildInput(state.priceMax, rangeMax);

    inputWrap.appendChild(min.box);
    inputWrap.appendChild(sep);
    inputWrap.appendChild(max.box);
    wrap.appendChild(inputWrap);

    var slider = buildDualSlider(
      rangeMin,
      rangeMax,
      state.priceMin !== '' ? Number(state.priceMin) : rangeMin,
      state.priceMax !== '' ? Number(state.priceMax) : rangeMax,
      function (dragMin, dragMax) {
        min.input.value = dragMin;
        max.input.value = dragMax;
      },
      function (finalMin, finalMax) {
        onChange(finalMin, finalMax);
      }
    );
    wrap.appendChild(slider.el);

    function fireChange() {
      slider.setValues(
        min.input.value !== '' ? Number(min.input.value) : rangeMin,
        max.input.value !== '' ? Number(max.input.value) : rangeMax
      );
      onChange(min.input.value, max.input.value);
    }
    min.input.addEventListener('change', fireChange);
    max.input.addEventListener('change', fireChange);

    return {
      el: buildFilterGroup('Preis', wrap),
      // Wird bei jeder Trefferaktualisierung neu aufgerufen, damit die
      // Spanne immer billigstes bis teuerstes Produkt der AKTUELLEN
      // Ergebnisse zeigt (Michelle 17.07.).
      updateRange: function (newMin, newMax) {
        rangeMin = newMin;
        rangeMax = newMax;
        min.input.placeholder = newMin;
        max.input.placeholder = newMax;
        slider.setRange(newMin, newMax);
      }
    };
  }

  /**
   * Volle Ergebnisseite: nutzt denselben Grid-Wrapper (Klassen +
   * data-Attribute) wie main-search.liquid, damit Spaltenzahl/Abstand exakt
   * zur bestehenden Kollektionsseite passen. Plus Filter-Sidebar (Lagerbestand,
   * Preis, Sortierung) fuer Feature-Paritaet mit der alten nativen Suche.
   */
  // Mobile Filter-Schublade (Michelle 18.07.: "die sieht deutlich passender
  // aus dem Originalzustand") - Original-Klassen filter-drawer/-inner/-wash,
  // slide-in von rechts per CSS (translateX), genau wie im Theme. Bewusste
  // Vereinfachung: die Filtergruppen bleiben aufklappbare Akkordeons (wie in
  // der Desktop-Sidebar) statt einzelner Drill-down-Unterseiten pro Gruppe -
  // spart Komplexitaet, optisch/funktional trotzdem sehr nah am Original.
  function buildFilterDrawer(sidebarEl, getResultsCount, onReset) {
    var root = document.createElement('div');
    root.className = 'filter-drawer';
    root.id = 'youro-filter-drawer';
    root.setAttribute('aria-hidden', 'true');

    var innerWrap = document.createElement('div');
    innerWrap.className = 'filter-drawer__inner';

    var content = document.createElement('div');
    content.className = 'filter-drawer__content';

    var headerWrap = document.createElement('div');
    headerWrap.className = 'filter-drawer__header-form-wrapper';

    var header = document.createElement('div');
    header.className = 'filter-drawer__header';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'filter-drawer__close';
    closeBtn.setAttribute('aria-label', 'Schliessen');
    closeBtn.appendChild(buildCloseIcon());
    header.appendChild(closeBtn);

    var title = document.createElement('h4');
    title.className = 'filter-drawer__title';
    title.textContent = 'Filter';
    header.appendChild(title);

    headerWrap.appendChild(header);

    var body = document.createElement('div');
    body.className = 'filter-form__content';
    body.setAttribute('data-form-type', 'drawer');
    headerWrap.appendChild(body);
    content.appendChild(headerWrap);

    var footer = document.createElement('div');
    footer.className = 'filter-drawer__footer';

    // Michelle 19.07.: nur EIN zusaetzlicher Button, weiss mit brauner
    // Umrandung, "Filter zuruecksetzen" - kein zweiter "Filter anwenden"-
    // Button noetig (das erledigt der bestehende Ergebnisse-Button).
    var resetBtn = document.createElement('button');
    resetBtn.type = 'button';
    resetBtn.className = 'filter-drawer__button-reset btn';
    resetBtn.textContent = 'Filter zurücksetzen';
    footer.appendChild(resetBtn);

    var applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'filter-drawer__button-apply btn btn--primary';
    var applyText = document.createElement('span');
    applyText.className = 'filter-drawer__button-apply-text';
    applyBtn.appendChild(applyText);
    footer.appendChild(applyBtn);
    content.appendChild(footer);

    resetBtn.addEventListener('click', function () { if (onReset) { onReset(); } });

    innerWrap.appendChild(content);
    root.appendChild(innerWrap);

    var wash = document.createElement('div');
    wash.className = 'filter-drawer__wash';
    root.appendChild(wash);

    function updateApplyText() {
      // Michelle 20.07.: "Filter anwenden (X)" statt "Ergebnisse anzeigen
      // (X Treffer)" - nur die Zahl in Klammern, damit der Button in zwei
      // Zeilen passt statt ueberzulaufen. getResultsCount() liefert
      // "N Treffer" (siehe lastCountText) - nur die Ziffern extrahieren.
      var countMatch = /\d+/.exec(getResultsCount());
      applyText.textContent = 'Filter anwenden (' + (countMatch ? countMatch[0] : getResultsCount()) + ')';
    }

    function open() {
      // Filtergruppen aus der Sidebar in die Schublade verschieben (nicht
      // klonen) - dieselben DOM-Knoten, dieselben Klick-Handler, kein
      // doppelter Zustand.
      while (sidebarEl.firstChild) { body.appendChild(sidebarEl.firstChild); }
      updateApplyText();
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      while (body.firstChild) { sidebarEl.appendChild(body.firstChild); }
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', close);
    wash.addEventListener('click', close);
    applyBtn.addEventListener('click', close);

    document.body.appendChild(root);

    function isOpen() {
      return root.getAttribute('aria-hidden') === 'false';
    }

    // Wie close(), aber ohne die Schublade optisch zuzuklappen - fuer den
    // Reset, der die Filtergruppen komplett neu aufbaut: erst die alten
    // (jetzt in der Schublade lebenden) Knoten zurueck in die Sidebar holen,
    // damit buildSidebar() sie beim Neuaufbau wirklich ersetzt statt die
    // frischen Gruppen zusaetzlich reinzuhaengen (sonst doppelte Checkboxen).
    function evacuateToSidebar() {
      while (body.firstChild) { sidebarEl.appendChild(body.firstChild); }
    }

    return { open: open, close: close, updateApplyText: updateApplyText, isOpen: isOpen, evacuateToSidebar: evacuateToSidebar };
  }

  // Topbar oberhalb der Trefferliste - Original-Struktur (Filter-Schublade-
  // Button mobil, Sidebar-Toggle Desktop, Kachel/Listen-Umschalter,
  // Sortierung rechtsbuendig, Trefferzahl) - Michelle 18.07.
  function buildTopbar(sidebarEl, itemLayoutRoot, state, onSortChange) {
    var wrap = document.createElement('div');
    wrap.className = 'filter-topbar-wrap';

    var bar = document.createElement('div');
    bar.className = 'filter-topbar';

    var inner = document.createElement('div');
    inner.className = 'filter-topbar__inner';
    // Original setzt diese CSS-Variable inline per Liquid (steuert den
    // Abstand zwischen den Topbar-Buttons auf Mobil) - ohne sie faellt der
    // Abstand auf 0 und alles quetscht sich zusammen (Michelle 19.07.).
    inner.style.setProperty('--topbar-gap-mobile', '8px');

    // Desktop (>=1024px): Sidebar ein-/ausblenden
    var sidebarToggleWrap = document.createElement('div');
    sidebarToggleWrap.className = 'filter-topbar__sidebar-toggle-wrapper';
    var sidebarBtn = document.createElement('button');
    sidebarBtn.type = 'button';
    sidebarBtn.className = 'filter-topbar__sidebar-toggle btn btn--tertiary';
    sidebarBtn.setAttribute('aria-expanded', 'true');
    sidebarBtn.appendChild(buildFilterIcon());
    var sidebarBtnText = document.createElement('span');
    sidebarBtnText.className = 'filter-topbar__sidebar-toggle-text';
    var showLabel = document.createElement('span');
    showLabel.className = 'toggle-text__title--show';
    showLabel.textContent = 'Filter anzeigen';
    var hideLabel = document.createElement('span');
    hideLabel.className = 'toggle-text__title--hide';
    hideLabel.textContent = 'Filter ausblenden';
    sidebarBtnText.appendChild(showLabel);
    sidebarBtnText.appendChild(hideLabel);
    sidebarBtn.appendChild(sidebarBtnText);
    sidebarToggleWrap.appendChild(sidebarBtn);

    var resultsCountDesktop = document.createElement('p');
    resultsCountDesktop.className = 'filter-topbar__results-count';
    sidebarToggleWrap.appendChild(resultsCountDesktop);
    inner.appendChild(sidebarToggleWrap);

    sidebarBtn.addEventListener('click', function () {
      var expanded = sidebarBtn.getAttribute('aria-expanded') === 'true';
      sidebarBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sidebarEl.style.display = expanded ? 'none' : '';
    });

    // Mobil/Tablet (<1024px): Filter-Schublade oeffnen
    var drawerBtn = document.createElement('button');
    drawerBtn.type = 'button';
    drawerBtn.className = 'filter-topbar__drawer-toggle btn btn--tertiary';
    drawerBtn.appendChild(buildFilterIcon());
    var drawerBtnText = document.createElement('span');
    drawerBtnText.className = 'filter-topbar__drawer-toggle-text';
    drawerBtnText.textContent = 'Filter';
    drawerBtn.appendChild(drawerBtnText);
    inner.appendChild(drawerBtn);

    var spacer = document.createElement('div');
    spacer.className = 'filter-topbar__spacer';
    inner.appendChild(spacer);

    // Original wrappt den Kachel/Listen-Umschalter in .filter-bar__item-layout
    // (traegt die order:2-Regel fuers Mobil-Layout) - ohne den Wrapper hat der
    // Umschalter keine eigene CSS-order und quetscht sich falsch ein.
    var itemLayoutWrap = document.createElement('div');
    itemLayoutWrap.className = 'filter-bar__item-layout';
    itemLayoutWrap.appendChild(buildItemLayoutToggle(itemLayoutRoot));
    inner.appendChild(itemLayoutWrap);

    inner.appendChild(buildSortDropdown(state, onSortChange));

    var resultsCountMobileWrap = document.createElement('div');
    resultsCountMobileWrap.className = 'filter-topbar__results-count-wrapper';
    // Original setzt order/width hier ebenfalls per CSS-Variable inline
    // (--results-order: 5, --results-width: 100%) - erzwingt den Zeilenumbruch
    // auf Mobil, damit die Trefferzahl allein unter den Buttons steht statt
    // dazwischengequetscht (Michelle 19.07., Vergleichsscreenshot Original).
    resultsCountMobileWrap.style.order = '5';
    resultsCountMobileWrap.style.width = '100%';
    var resultsCountMobile = document.createElement('p');
    resultsCountMobile.className = 'filter-topbar__results-count';
    resultsCountMobileWrap.appendChild(resultsCountMobile);
    inner.appendChild(resultsCountMobileWrap);

    bar.appendChild(inner);
    wrap.appendChild(bar);

    return {
      el: wrap,
      drawerToggleButton: drawerBtn,
      setResultsCount: function (text) {
        resultsCountDesktop.textContent = text;
        resultsCountMobile.textContent = text;
      }
    };
  }

  function renderNativeResultsPage(topEl, containerEl, sidebarEl, options) {
    options = options || {};
    // pageSize = wie viele Kacheln pro angezeigter Seite (unveraendert 24).
    // FETCH_SIZE = wie viele Treffer insgesamt EINMAL von Meilisearch
    // geholt werden - bewusst grosszuegig (2026-10-08, Bug-Report: "nur 24
    // von 44 Treffern sichtbar, keine Pagination"). Kartenrendering selbst
    // (fetchCardsInOrder) ist teuer (1 Netzwerk-Aufruf pro Produkt ueber die
    // Section-Rendering-API), deshalb werden beim Seitenwechsel NICHT alle
    // FETCH_SIZE Treffer neu gerendert, sondern nur aus dem bereits
    // geholten Datensatz (lastAllHits) die passende Seite neu ausgeschnitten
    // und gerendert - kein neuer Meilisearch-Aufruf noetig.
    var pageSize = options.limit || 24;
    var FETCH_SIZE = 300;
    var state = readStateFromUrl();
    var lastAllHits = [];

    var heading = document.createElement('div');
    heading.className = 'youro-search-heading';
    (topEl || containerEl).appendChild(heading);

    // Original hat den "Filter ausblenden"-Balken ueber der GANZEN Breite
    // (Sidebar + Ergebnisse), nicht nur innerhalb der Ergebnisspalte - sonst
    // wirkt er eingerueckt (Michelle 16.07., Vergleichsscreenshot).
    var itemLayoutRoot = (containerEl.closest && containerEl.closest('.search.section')) || containerEl;
    var drawer = sidebarEl ? buildFilterDrawer(sidebarEl, function () { return lastCountText; }, function () { resetFilters(); }) : null;
    var topbar = sidebarEl ? buildTopbar(sidebarEl, itemLayoutRoot, state, function (value) {
      onFilterChange({ sort: value });
    }) : null;
    if (topbar) {
      (topEl || containerEl).appendChild(topbar.el);
      if (drawer) { topbar.drawerToggleButton.addEventListener('click', drawer.open); }
    }
    var lastCountText = '0 Treffer';

    var grid = document.createElement('div');
    grid.className = 'search__results standard-grid-spacing product-item-holder collection__products';
    grid.setAttribute('data-standard-grid-spacing-type', 'product-list');
    // Original braucht data-grid-style="default" auf dem Holder, sonst greift
    // die Listenansicht-Regel fuer den Abstand Bild->Text nicht (Michelle
    // 19.07.: Text klebt am Bild in der Listenansicht).
    grid.setAttribute('data-grid-style', 'default');
    containerEl.appendChild(grid);

    // Pagination-Leiste unter dem Ergebnis-Raster (2026-10-08, Bug-Report:
    // "nur 24 Treffer sichtbar, kein Weg zu den restlichen"). Bleibt leer/
    // unsichtbar, solange alle Treffer auf eine Seite passen.
    var pager = document.createElement('div');
    pager.className = 'youro-search-pager';
    containerEl.appendChild(pager);

    // Ladezustand als eigenes Overlay UEBER die ganze Breite (Sidebar +
    // Ergebnisse), nicht nur in der Raster-Spalte - sonst haengt er schief
    // links in der (noch leeren) Sidebar-Spalte statt in der Mitte der
    // weissen Flaeche zu stehen (Michelle 21.07., zweite Rueckmeldung).
    // Inline gesetztes position:relative bleibt auf DIESEN einen Node
    // beschraenkt, keine globale CSS-Aenderung an der nativen
    // .search__main-area-Klasse noetig.
    var mainAreaEl = (containerEl.closest && containerEl.closest('.search__main-area')) || containerEl;
    if (mainAreaEl.style.position !== 'relative') { mainAreaEl.style.position = 'relative'; }
    var loadingOverlay = document.createElement('div');
    loadingOverlay.innerHTML = LOADING_OVERLAY_HTML;
    loadingOverlay = loadingOverlay.firstElementChild;

    var requestId = 0;
    var availableToggle = null;
    var priceGroup = null;
    // 0-Treffer-Suchen im Erkenntnis-Dashboard protokollieren (anderer Chat,
    // Nachtrag 21.07.) - nur einmal pro echter Suche (nicht bei jeder
    // Filter-Aenderung), siehe Markierung unten bei countText.
    var hasLoggedZeroResults = false;

    function runSearch() {
      heading.textContent = state.q ? ('Ergebnisse für „' + state.q + '“') : 'Suche';
      if (!state.q) { return Promise.resolve(); }

      requestId += 1;
      var thisRequestId = requestId;
      // Sofort den Ladezustand zeigen statt die (bis zu 1,5s) leere Flaeche,
      // die aussah wie "keine Treffer" (Michelle 20.07.).
      mainAreaEl.appendChild(loadingOverlay);
      var filter = buildMeiliFilter(state);
      var sort = sortValueToMeiliSort(state.sort);

      // Zweite, leichte Anfrage (limit 0) nur fuer die Preis-Spanne - OHNE
      // den Preisfilter selbst, sonst wuerde die Reglerspanne beim Ziehen auf
      // genau die aktuelle Auswahl zusammenschrumpfen (Michelle 17.07.).
      var statsPromise = global.YouroSearch.searchAdvanced(state.q, {
        limit: 0,
        facets: ['price_min'],
        filter: buildMeiliFilter(state, { excludePrice: true })
      });

      // Basis-Suchoptionen ohne Bedeutungssuche - werden sowohl fuer den
      // Hybrid-Aufruf (per Object.assign erweitert) als auch fuer den
      // 0-Treffer-Fallback direkt darunter gebraucht (anderer Chat,
      // Nachtrag 21.07.: Bug-Report "hosse" -> 0 Treffer).
      var mainSearchOptions = {
        limit: FETCH_SIZE,
        facets: ['price_min', 'available', 'colors', 'country_of_origin', 'vendor_name', 'product_type'],
        filter: filter,
        sort: sort
      };
      var hybridOptions = Object.assign({}, mainSearchOptions, {
        // KI-Bedeutungssuche nur hier auf der vollen Ergebnisseite (Update
        // des anderen Chats 17.07.) - faellt bei Zeitueberschreitung
        // automatisch und unsichtbar auf normale Suche zurueck, siehe
        // searchAdvanced() in youro-search.js. Kapsel bleibt unveraendert.
        hybrid: { embedder: 'gemini', semanticRatio: 0.5 },
        rankingScoreThreshold: 0.8,
        timeoutMs: 1500
      });

      function fetchMainData() {
        return global.YouroSearch.searchAdvanced(state.q, hybridOptions).then(function (hybridData) {
          var hybridTotal = hybridData.totalHits != null ? hybridData.totalHits : (hybridData.estimatedTotalHits || 0);
          if (hybridTotal === 0) {
            // Die Bedeutungssuche kann technisch erfolgreich durchlaufen und
            // trotzdem 0 Treffer liefern, obwohl passende Produkte existieren
            // - z.B. bei Tippfehlern ("hosse" statt "hose"): Meilisearchs
            // eigene Tippfehler-Toleranz findet die richtigen Produkte in der
            // reinen Keyword-Suche zuverlaessig, aber Gemini bildet den
            // falsch geschriebenen Suchtext woertlich ab - die Embedding-
            // Aehnlichkeit faellt dann unter rankingScoreThreshold, auch fuer
            // die eigentlich richtigen Treffer (live bestaetigt: "hosse"
            // lieferte 0 statt 177 Treffer). Der Fehler-Fallback im .catch()
            // unten greift hier nicht, weil kein Fehler geworfen wird -
            // deshalb zusaetzlich auf 0 Treffer pruefen und auf reine
            // Keyword-Suche zurueckfallen, bevor "Keine Treffer" angezeigt
            // wird (anderer Chat, Nachtrag 21.07., identischer Fix wie in
            // youro-search.js).
            return global.YouroSearch.searchAdvanced(state.q, mainSearchOptions);
          }
          // Verwandter, aber anderer Fall (2026-09-08, live gefunden bei der
          // Suche "herder"): die Bedeutungssuche liefert NICHT 0, sondern
          // eine kleine, aber FALSCHE Teilmenge, wenn ein Markenname im
          // Suchbegriff steckt. Der Markenname wird nicht mit eingebettet
          // (siehe config/embedder.json documentTemplate), daher scort nur
          // das Produkt hoch, das den Suchbegriff zusaetzlich woertlich im
          // Titel hat - alle anderen Produkte derselben Marke fallen unter
          // rankingScoreThreshold, obwohl sie fachlich genauso passen.
          //
          // 2026-09-14 Nachbesserung: die erste Version davon hat nur die
          // Top-N (mainSearchOptions.limit) Treffer der normalen Suche nach
          // passenden Marken durchsucht - bei einem breiten Gattungsbegriff
          // wie "messer" lagen viele weitere Marken-Treffer aber ausserhalb
          // dieses Fensters (live: "messer" zeigte nur 24 von echten 49
          // moeglichen Treffern fuer die gefundenen Marken). Fix: statt im
          // Top-N-Fenster zu suchen, GEZIELT nach allen Produkten der
          // gefundenen Marken filtern (Meilisearch filter=vendor_name IN
          // [...]) - liefert die komplette Marken-Treffermenge, nicht nur
          // einen Zufallsausschnitt. Michelles ausdruecklicher Wunsch: lieber
          // mehr (auch nur locker passende) Treffer zeigen, sortiert nach
          // Relevanz, als etwas verstecken - deshalb hier bewusst grosszuegig.
          var hybridHits = hybridData.hits || [];
          var hybridVendors = {};
          var hybridIds = {};
          hybridHits.forEach(function (h) {
            if (h.vendor_name) hybridVendors[h.vendor_name] = true;
            hybridIds[h.id] = true;
          });
          var vendorNames = Object.keys(hybridVendors);
          if (!vendorNames.length) {
            return hybridData;
          }
          var vendorClause = vendorNames.map(function (v) {
            return 'vendor_name = "' + String(v).replace(/"/g, '\\"') + '"';
          }).join(' OR ');
          var vendorScopedOptions = Object.assign({}, mainSearchOptions, {
            limit: FETCH_SIZE, // grosszuegig - deckt auch grosse Marken komplett ab
            filter: mainSearchOptions.filter ? '(' + mainSearchOptions.filter + ') AND (' + vendorClause + ')' : vendorClause,
          });

          return global.YouroSearch.searchAdvanced(state.q, vendorScopedOptions).then(function (plainData) {
            var extra = (plainData.hits || []).filter(function (h) {
              return !hybridIds[h.id];
            });
            if (!extra.length) {
              return hybridData;
            }
            var mergedHits = hybridHits.concat(extra);
            // WICHTIG: nicht hybridTotal + extra.length rechnen - hybridTotal
            // ist bereits die vollstaendige Trefferzahl fuer diese Marke(n)
            // aus der Bedeutungssuche, auch wenn hybridHits (das Array) durch
            // hitsPerPage gekappt ist. Die gezielte Marken-Suche (plainData)
            // deckt IMMER eine gleich grosse oder groessere Menge ab (kein
            // Score-Schwellenwert) - ihre eigene totalHits-Zahl ist daher
            // bereits die korrekte Gesamtzahl. Frueher wurde hier addiert,
            // was bei Marken mit >hitsPerPage Bedeutungssuche-Treffern zu
            // einer Doppelzaehlung fuehrte (live gefunden: "woodkopf" zeigte
            // faelschlich 58 statt korrekt 41).
            hybridData.totalHits = plainData.totalHits != null ? plainData.totalHits : (plainData.estimatedTotalHits || mergedHits.length);
            hybridData.estimatedTotalHits = hybridData.totalHits;
            // NICHT mehr auf die Seitengroesse kappen (2026-10-08, Bug-Report
            // Pagination) - der volle, gemergte Datensatz (bis FETCH_SIZE)
            // bleibt erhalten, damit alle Seiten paginierbar sind. Das
            // Zuschneiden auf die aktuell sichtbare Seite passiert erst ganz
            // unten beim Rendern (sliceForPage), nicht mehr hier.
            hybridData.hits = mergedHits;
            // Facetten-Zaehler (Marken-/Kategorie-Filter in der Sidebar) aus
            // den tatsaechlich gefundenen, gemergten Treffern neu berechnen
            // - sonst zeigen die Filter-Chips weiter die alten, zu
            // niedrigen Zahlen aus der reinen Bedeutungssuche.
            var facetDistribution = hybridData.facetDistribution || {};
            var vendorCounts = {};
            mergedHits.forEach(function (h) {
              if (h.vendor_name) vendorCounts[h.vendor_name] = (vendorCounts[h.vendor_name] || 0) + 1;
            });
            facetDistribution.vendor_name = vendorCounts;
            var typeCounts = {};
            mergedHits.forEach(function (h) {
              if (h.product_type) typeCounts[h.product_type] = (typeCounts[h.product_type] || 0) + 1;
            });
            facetDistribution.product_type = typeCounts;
            var availTrue = 0, availFalse = 0;
            mergedHits.forEach(function (h) {
              if (h.available) availTrue++; else availFalse++;
            });
            facetDistribution.available = { "true": availTrue, "false": availFalse };
            hybridData.facetDistribution = facetDistribution;
            return hybridData;
          });
        });
      }

      return Promise.all([
        fetchMainData(),
        statsPromise
      ]).then(function (results) {
        var data = results[0];
        var statsData = results[1];
        if (thisRequestId !== requestId) { return; }
        loadingOverlay.remove();
        var hits = sortAvailableFirst(data.hits || []);
        // estimatedTotalHits ist seit rankingScoreThreshold (anderer Chat,
        // 18.07.) wieder zuverlaessig, auch bei Bedeutungssuche - eigener
        // Umgehungs-Workaround von gestern nicht mehr noetig.
        var countText = (data.estimatedTotalHits || hits.length) + ' Treffer';
        lastCountText = countText;
        if (topbar) { topbar.setResultsCount(countText); }
        if (drawer) { drawer.updateApplyText(); }

        // 0-Treffer-Suchen im Erkenntnis-Dashboard ("Erfolglose Suchen") -
        // nur einmal pro echter Suche, und erst NACH dem Tippfehler-Fallback
        // oben (also nur echte 0-Treffer, keine, die nur an
        // rankingScoreThreshold gescheitert sind, siehe Entscheidung 011,
        // fuenfte Nachbesserung). window.YouroTrack kapselt Session-ID/
        // Consent/CORS selbst - loest bei fehlender Funktion (Snippet noch
        // nicht im Theme eingebunden) einfach gar nichts aus.
        if (!hasLoggedZeroResults) {
          hasLoggedZeroResults = true;
          var totalHitsForLog = data.estimatedTotalHits || hits.length;
          if (totalHitsForLog === 0 && global.YouroTrack) {
            global.YouroTrack('search_zero_results', { meta: state.q });
          }
        }

        var availableCount = data.facetDistribution && data.facetDistribution.available
          ? (data.facetDistribution.available['true'] || 0)
          : 0;
        if (availableToggle) { availableToggle.setCount(availableCount); }

        var priceStats = statsData.facetStats && statsData.facetStats.price_min;
        if (priceGroup && priceStats) {
          priceGroup.updateRange(Math.floor(priceStats.min), Math.ceil(priceStats.max));
        }

        if (sidebarEl && !sidebarEl.dataset.built) {
          buildSidebar(data, priceStats);
          sidebarEl.dataset.built = 'true';
        }

        if (!hits.length) {
          grid.innerHTML = '<div class="youro-search-empty">Keine Treffer gefunden.</div>';
          pager.innerHTML = '';
          return;
        }
        // Voller (bis zu FETCH_SIZE grosser) Datensatz merken - "Mehr
        // anzeigen" schneidet nur noch daraus, ohne neuen Meilisearch-
        // Aufruf (2026-10-08, Bug-Report: nur 24 Treffer erreichbar;
        // 2026-10-08 Nachbesserung: "Mehr anzeigen" statt Seiten-Wechsel,
        // Michelles ausdruecklicher Wunsch - anfuegen statt umblaettern).
        lastAllHits = hits;
        var totalPages = Math.max(1, Math.ceil(hits.length / pageSize));
        if (state.page > totalPages) { state.page = totalPages; writeStateToUrl(state); }
        if (state.page < 1) { state.page = 1; writeStateToUrl(state); }
        // Initialer Render (neue Suche/Filteraenderung, auch bei Deep-Link
        // auf page=N): zeigt alle bereits "geladenen" Seiten 1..state.page
        // auf einmal, ersetzt den kompletten Grid-Inhalt.
        return renderLoaded(thisRequestId, true);
      }).catch(function () {
        if (thisRequestId === requestId) {
          loadingOverlay.remove();
          grid.textContent = 'Suche momentan nicht verfügbar.';
        }
      });
    }

    // Rendert die Kacheln fuer alle bisher "geladenen" Seiten (1 bis
    // state.page) aus dem bereits geholten lastAllHits - kein neuer
    // Meilisearch-Aufruf. replace=true ersetzt den Grid-Inhalt komplett
    // (neue Suche/Filteraenderung/Erstladung inkl. Deep-Link auf page=N),
    // replace=false haengt nur das NEU hinzugekommene Stueck an (Klick auf
    // "Mehr anzeigen") - fetchCardsInOrder (1 Netzwerk-Aufruf pro Kachel
    // ueber die Section-Rendering-API) laeuft dann nur fuer die neuen
    // Kacheln, nicht fuer die schon angezeigten (2026-10-08).
    function renderLoaded(thisRequestId, replace) {
      var upTo = state.page * pageSize;
      var hitsToRender = replace ? lastAllHits.slice(0, upTo) : lastAllHits.slice((state.page - 1) * pageSize, upTo);
      renderLoadMoreButton();
      mainAreaEl.appendChild(loadingOverlay);
      return fetchCardsInOrder(hitsToRender).then(function (cardHtmls) {
        if (thisRequestId !== requestId) { return; }
        loadingOverlay.remove();
        var html = cardHtmls.filter(Boolean).join('');
        if (replace) { grid.innerHTML = html; }
        else { grid.insertAdjacentHTML('beforeend', html); }
      });
    }

    function loadMore() {
      var totalPages = Math.max(1, Math.ceil(lastAllHits.length / pageSize));
      if (state.page >= totalPages) { return; }
      state.page += 1;
      writeStateToUrl(state);
      requestId += 1;
      var thisRequestId = requestId;
      // replace=false: nur die neu hinzugekommene Seite wird gerendert und
      // ans bestehende Grid angehaengt - kein Hochscrollen/Neuladen der
      // bereits sichtbaren Kacheln, der Nutzer bleibt an seiner Scroll-
      // Position und sieht die neuen Produkte direkt darunter erscheinen.
      renderLoaded(thisRequestId, false);
    }

    function renderLoadMoreButton() {
      pager.innerHTML = '';
      var totalPages = Math.max(1, Math.ceil(lastAllHits.length / pageSize));
      if (state.page >= totalPages) { return; }

      var loadMoreBtn = document.createElement('button');
      loadMoreBtn.type = 'button';
      loadMoreBtn.className = 'youro-search-pager__nav youro-search-pager__nav--more';
      var shown = Math.min(state.page * pageSize, lastAllHits.length);
      loadMoreBtn.textContent = 'Weitere Produkte anzeigen (' + shown + ' von ' + lastAllHits.length + ')';
      loadMoreBtn.addEventListener('click', loadMore);
      pager.appendChild(loadMoreBtn);
    }

    function onFilterChange(patch) {
      // Bei jeder Filter-/Sortierungs-Aenderung zurueck auf Seite 1 - die
      // Ergebnismenge aendert sich komplett, eine alte Seitenzahl waere
      // sonst sinnlos bzw. ausserhalb des neuen Bereichs (2026-10-08).
      state.page = 1;
      Object.assign(state, patch);
      writeStateToUrl(state);
      runSearch();
    }

    // Michelle 19.07.: "Filter zuruecksetzen"-Button in der mobilen
    // Schublade. Sortierung bleibt bewusst unangetastet - nur die Filter-
    // Kriterien werden geleert. sidebarEl.dataset.built wird zurueckgesetzt,
    // damit runSearch() die Filtergruppen mit dem geleerten Zustand neu
    // aufbaut (Haken/Regler zeigen danach wieder "nichts ausgewaehlt").
    function resetFilters() {
      Object.assign(state, {
        available: false,
        priceMin: '',
        priceMax: '',
        colors: [],
        countries: [],
        vendors: [],
        productTypes: []
      });
      writeStateToUrl(state);
      var wasOpen = drawer && drawer.isOpen();
      if (wasOpen) { drawer.evacuateToSidebar(); }
      if (sidebarEl) { sidebarEl.dataset.built = ''; }
      runSearch().then(function () {
        // Die neu gebauten Filtergruppen landen erst wieder in der Sidebar -
        // war die Schublade offen, muessen sie sofort zurueck in die
        // Schublade verschoben werden (move-dont-clone), sonst sieht man sie
        // dort nicht mehr.
        if (wasOpen && drawer) { drawer.open(); }
      });
    }

    function buildSidebar(initialData, priceStats) {
      sidebarEl.innerHTML = '';

      var availableCount = initialData.facetDistribution && initialData.facetDistribution.available
        ? (initialData.facetDistribution.available['true'] || 0)
        : 0;
      availableToggle = buildToggleFilterItem('Nur auf Lager', availableCount, state.available, function (checked) {
        onFilterChange({ available: checked });
      });
      sidebarEl.appendChild(availableToggle.el);

      // Sortierung ist in die Topbar umgezogen (Michelle 18.07.: "wie im
      // Original rechtsbuendig als Dropdown") - buildSortGroup() bleibt im
      // Code, wird hier aber nicht mehr in die Sidebar gehaengt.

      priceGroup = buildPriceGroup(state, priceStats, function (minVal, maxVal) {
        onFilterChange({ priceMin: minVal, priceMax: maxVal });
      });
      sidebarEl.appendChild(priceGroup.el);

      // Reihenfolge (Michelle 19.07.: "Preis, dann Farbe, dann Kategorie,
      // dann Marke, dann Produktionsland").
      var colorEntries = facetEntries(initialData.facetDistribution, 'colors', 14);
      if (colorEntries.length) {
        sidebarEl.appendChild(buildCheckboxGroup('Farbe', colorEntries, function (v) { return v; }, state.colors, function (value, checked) {
          var next = state.colors.slice();
          if (checked) { if (next.indexOf(value) === -1) { next.push(value); } }
          else { next = next.filter(function (v) { return v !== value; }); }
          onFilterChange({ colors: next });
        }, true));
      }

      var productTypeEntries = facetEntries(initialData.facetDistribution, 'product_type', 14);
      if (productTypeEntries.length) {
        sidebarEl.appendChild(buildCheckboxGroup('Kategorie', productTypeEntries, humanizeProductType, state.productTypes, function (value, checked) {
          var next = state.productTypes.slice();
          if (checked) { if (next.indexOf(value) === -1) { next.push(value); } }
          else { next = next.filter(function (v) { return v !== value; }); }
          onFilterChange({ productTypes: next });
        }));
      }

      var vendorEntries = facetEntries(initialData.facetDistribution, 'vendor_name', 14);
      if (vendorEntries.length) {
        sidebarEl.appendChild(buildCheckboxGroup('Marke', vendorEntries, function (v) { return v; }, state.vendors, function (value, checked) {
          var next = state.vendors.slice();
          if (checked) { if (next.indexOf(value) === -1) { next.push(value); } }
          else { next = next.filter(function (v) { return v !== value; }); }
          onFilterChange({ vendors: next });
        }));
      }

      var countryEntries = facetEntries(initialData.facetDistribution, 'country_of_origin', 14);
      if (countryEntries.length) {
        sidebarEl.appendChild(buildCheckboxGroup('Produktionsland', countryEntries, humanizeCountry, state.countries, function (value, checked) {
          var next = state.countries.slice();
          if (checked) { if (next.indexOf(value) === -1) { next.push(value); } }
          else { next = next.filter(function (v) { return v !== value; }); }
          onFilterChange({ countries: next });
        }));
      }
    }

    runSearch();
  }

  global.YouroSearchNative = {
    attachAutocomplete: attachNativeAutocomplete,
    renderResultsPage: renderNativeResultsPage
  };
})(window);
